<template>
    <div>
        <div class="simple-form">
            <div class="form-group col-6 fl" style="padding-left: 0px;">
                <div class="form-label">
                    <label></label>
                </div>
                <div class="form-value">
                    <el-checkbox v-model="autoApply" @change="autoApplyChange">自动申请</el-checkbox>
                </div>
            </div>
            <div class="form-group col-6 fl" v-if="autoApply">
                <div class="form-label">
                    <label></label>
                </div>
                <div class="form-value">
                    <el-checkbox v-model="autoAudit">自动审核</el-checkbox>
                </div>
            </div>
        </div>
        <div style="width: 100%;overflow-y: auto">
            <span class="font-orange">【共{{servicerCount()}}个配件提供商，{{(accList || []).length}}个配件】</span>
            <table class="custom-tbl">
                <thead class="head">
                <tr class="row">
                    <th width="200" style="text-align: left">服务商</th>
                    <th width="120" style="text-align: left">原出库仓库</th>
                    <th width="200" style="text-align: left">配件名称</th>
                    <th width="120" style="text-align: left">分类</th>
                    <th width="120" style="text-align: left">品牌</th>
                    <th width="180" style="text-align: left">规格</th>
                    <th width="150" style="text-align: left">厂商序列号</th>
                    <th width="160" style="text-align: left">设备名称</th>
                    <th width="120" style="text-align: left">故障说明</th>
                    <th width="80" align="left">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="accInfo in accList">
                    <td style="text-align: left">{{accInfo.srcServicerName}}</td>
                    <td style="text-align: left">{{accInfo.srcWarehouseName}}</td>
                    <td style="text-align: left">{{accInfo.name}}</td>
                    <td style="text-align: left">{{accInfo.catName}}</td>
                    <td style="text-align: left">{{accInfo.brandName}}</td>
                    <td style="text-align: left">{{accInfo.modelSpec}}</td>
                    <td style="text-align: left">{{accInfo.vendorSn}}</td>
                    <td style="text-align: left">{{accInfo.boundDevcName}}</td>
                    <td style="text-align: left">
                        <el-input v-model="accInfo.faultDesc" type="textarea"></el-input>
                    </td>
                    <td align="left"><a class="swb-btn-link" @click="removeAcc(accInfo)">移除</a></td>
                </tr>
                <tr class="row">
                    <td colspan="9" class="display-none">
                        <div class="no-data">
                            <i class="icon iconfont icon-zanwushuju mr10" style="font-size: 58px;vertical-align: middle;"></i>
                            <span class="">暂无数据 . . .</span>
                        </div>
                    </td>
                </tr>
                </tbody>
                <tfoot class="foot">
                <tr class="row">
                    <td colspan="9">
                        <div class="swb-btn-link" @click="selectAcc()">
                            <span>
                                <i class="icon iconfont icon-jiahao mr5"></i>选择配件
                            </span>
                        </div>
                    </td>
                </tr>
                </tfoot>
            </table>

        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openSpecificAccListForSelectDlg } from './dialog'

    import accStockApi from '../../api/accStock'

    export default{
        name: 'swb-specific-acc-repair-voucher-save',
        desc: '配件返修单保存',
        props: {
            voucherId: {
                type: Number,
                default: null
            },
            retailerComId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                accRepairVoucherInfo: {
                    specificAccRepairItems: []
                },
                accList: [],
                autoApply: false,
                autoAudit: false
            }
        },
        created: function () {
            //
            if(!Utils.isNoB(this.voucherId)) {
                this.getAccRepairVoucherInfo();
            }
        },
        methods: {
            autoApplyChange: function () {
                if(Utils.isFalse(this.autoApply)) {
                    this.autoAudit = false;
                }
            },
            // 选择配件
            selectAcc: function () {
                let self = this;
                let selectAccList = self.accList || [];
                let selectIds = [];
                for(let i = 0; i < selectAccList.length; i++) {
                    let accInfo = selectAccList[i];
                    if(!selectIds.contains(accInfo.specificAccId)) {
                        selectIds.push(accInfo.specificAccId);
                    }
                }
                let params = {
                    checkBox: true,
                    disabledSelect: true,
                    selectIds: selectIds,
                    filter: {
                        retailerComId: self.retailerComId,
                        locked: false,
                        repairingFlag: false,
                        scrapped: false,
                        invalid: false,
                        queryIncludeRented: true
                    }
                };
                if(!Utils.isNoB(self.voucherId)) {
                    params.filter.servicerId = self.accRepairVoucherInfo.servicerId;
                }
                openSpecificAccListForSelectDlg(params, function (accList, theDlg) {
                    theDlg.close();
                    accList = accList || [];
                    let accListNew = [];
                    for(let i = 0; i < accList.length; i++) {
                        let accInfo = accList[i];
                        let item = {
                            specificAccId: accInfo.id,
                            srcServicerId: accInfo.servicerId,
                            srcServicerName: accInfo.servicerName,
                            srcWarehouseId: accInfo.servicerWarehouseId,
                            srcWarehouseName: accInfo.servicerWarehouseName,
                            accId: accInfo.accId,
                            name: accInfo.name,
                            catName: accInfo.catName,
                            brandName: accInfo.brandName,
                            modelSpec: accInfo.modelSpec,
                            vendorSn: accInfo.vendorSn,
                            boundDevcName: accInfo.boundDevcName,
                        };
                        accListNew.push(item);
                    }
                    // 当前机构选中的设备信息
                    let currentAccList = selectAccList;
                    currentAccList = currentAccList.concat(accListNew);
                    self.accList = Utils.merge([], currentAccList);
                });
            },
            // 移除配件
            removeAcc: function (row) {
                let accList = this.accList || [];
                for(let i = 0; i < accList.length; i++) {
                    let accInfo = accList[i];
                    if(accInfo.srcServicerId == row.srcServicerId && accInfo.accId == row.accId && accInfo.vendorSn == row.vendorSn) {
                        accList.splice(i, 1);
                    }
                }
                this.accList = Utils.merge([], accList);
            },
            // 计算配件提供商数量
            servicerCount: function () {
                let servicerIds = [];
                let accList = this.accList || [];
                for(let i = 0; i < accList.length; i++) {
                    let accInfo = accList[i];
                    if(!servicerIds.contains(accInfo.srcServicerId)) {
                        servicerIds.push(accInfo.srcServicerId);
                    }
                }
                return servicerIds.length;
            },
            // 查看租赁详情
            getAccRepairVoucherInfo: function () {
                let self = this;
                let postData = {};
                postData.id = self.voucherId;
                //
                let msgBoxDlg = MsgBox.loading();
                accStockApi.getSpecificAccRepairVoucherInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let accRepairVoucherInfo = result.data;
                        self.accRepairVoucherInfo = Utils.merge({}, accRepairVoucherInfo);
                        //
                        let accList = accRepairVoucherInfo.specificAccRepairItems || [];
                        self.accList = Utils.merge([], accList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 返回数据
            getDlgResult: function () {
                let result = {};
                //
                let accRepairVoucherInfo = {};
                let accList = this.accList || [];
                if(accList.length <= 0) {
                    result.type = 'warn';
                    result.message = '请选择要返修的配件!';
                } else {
                    if(!Utils.isNoB(this.voucherId)) {
                        accRepairVoucherInfo = this.accRepairVoucherInfo;
                    } else {
                        accRepairVoucherInfo.retailerComId = this.retailerComId;
                    }
                    //
                    accRepairVoucherInfo.specificAccRepairItems = Utils.merge([], accList);
                    accRepairVoucherInfo.autoApply = this.autoApply;
                    accRepairVoucherInfo.autoAudit = Utils.isTrue(this.autoApply) ? this.autoAudit : false;
                    //
                    result.type = 'info';
                    result.data = accRepairVoucherInfo;
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/accStock/SpecificAccRepairVoucherSave.vue